import PropTypes from "prop-types";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { flowParts } from "../../../../utils/email-automations";

/** "Trigger → Filter → Send email → Delay · 3 days → Send email": the shape of an automation. */
const FlowChips = ({ automation }) => {
  const { t } = useTranslation("coaching-portal");
  const label = (part) => {
    if (part.kind !== "delay") return t(`emailAutomations.flow.${part.kind}`);
    return t("emailAutomations.flow.delay", {
      amount: part.amount,
      unit: t(`emailAutomations.activity.units.${part.unit}`, {
        count: part.amount,
      }),
    });
  };
  return (
    <ul className="ea-flow" aria-label={t("emailAutomations.flow.label")}>
      {flowParts(automation).map((part, index) => (
        // The parts repeat (two emails), so their place in the flow is the key
        <Fragment key={`${part.kind}-${index}`}>
          {index > 0 ? (
            <li className="ea-flow__arrow" aria-hidden="true">
              <img src="/img/new-icons/arrow-forward.svg" alt="" />
            </li>
          ) : null}
          <li className="ea-flow__chip">{label(part)}</li>
        </Fragment>
      ))}
    </ul>
  );
};

FlowChips.propTypes = {
  automation: PropTypes.shape({
    filters: PropTypes.object,
    steps: PropTypes.array,
  }).isRequired,
};

export default FlowChips;
